var React = require('react');

function Leaf60px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M49.419 36.209c-5.94 6.428-14.218 9.686-24.607 9.686h-.002c-4.729 0-9.969-.698-15.568-2.05-6.51 9.075-7.244 15.006-7.256 15.123a.995.995 0 1 1-1.978-.205c.053-.512.869-7.007 7.972-16.693-.16-3.892-.227-21.121 10.182-32.386 5.94-6.429 14.22-9.688 24.611-9.688 4.863 0 10.259.724 16.039 2.154a.995.995 0 0 1 .753.893c.063.839 1.399 20.673-10.146 33.166zm8.198-32.297C40.6-.14 27.712 2.282 19.619 11.041c-8.303 8.986-9.548 22.386-9.659 28.453 4.26-5.286 10.347-11.364 19.01-17.85V11.9c0-.551.451-.999 1-.999.549 0 1 .448 1 .999v8.264c5.416-3.913 11.771-7.961 19.242-12.062a.988.988 0 0 1 1.348.395 1 1 0 0 1-.395 1.355c-12.03 6.604-21.107 13.076-27.984 19.049H40.97c.549 0 1 .448 1 .999 0 .551-.451 1-1 1h-20l-.033-.001c-4.4 4.034-7.802 7.813-10.402 11.204 16.73 3.863 29.425 1.409 37.427-7.251 9.769-10.569 9.778-27.286 9.655-30.94z","key":1})]);
}

Leaf60px.displayName = "Leaf60px";

Leaf60px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 59.63 59.9"};

module.exports = Leaf60px;

Leaf60px.default = Leaf60px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/60px/leaf-60px.svg
// module id = 1199
// module chunks = 0